import React, { FC, useState } from 'react';
import Button from '../../components/UI/Button/Button';
import Input from '../../components/UI/Input/Input';
import classes from './Login.module.scss';
import { useAppDispatch } from '../../store/hooks';
import { customAlert } from '../../store/actions/alert';
import { login as loginAction } from '../../store/actions/auth'
import checkValidity from '../../helpers/checkValidity';
import Loader from '../UI/Loader/Loader';


const Login: FC = () => {
  const dispatch = useAppDispatch();
  const [loginForm, setLoginForm] = useState({
    username: {
      value: '',
      touched: false,
      isValid: false
    },
    password: {
      value: '',
      touched: false,
      isValid: false
    }
  });
  const [isLoading, setIsLoading] = useState(false);

  const login = () => {
    if (!loginForm.username.isValid) {
      dispatch(customAlert(true, 'Username is invalid'));
    }
    if (!loginForm.password.isValid) {
      dispatch(customAlert(true, 'Password is invalid'));
    } else {
      setIsLoading(true);
      dispatch(loginAction(
        loginForm.username.value,
        loginForm.password.value,
        (success, response) => {
          if (!success || response?.status !== 200) {
            setIsLoading(false);
          }
        }
      ));
    }
  };

  const updateLoginForm = (value: string, identifier: 'username' | 'password') => {
    if (value[value.length - 1] !== ' ') {
      let newLoginForm = { ...loginForm };
      newLoginForm[identifier].value = value;
      newLoginForm[identifier].touched = true;
      newLoginForm[identifier].isValid = checkValidity(value, {
        required: true,
        minLength: 3,
        maxLength: 40
      });
      setLoginForm(newLoginForm);
    }
  };

  return (
    <div className={classes.window}>
      <div className='title'>
        <span>Login</span>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          login();
        }}
      >
        <div className={classes['input-box']}>
          <Input
            elementType={'input'}
            elementConfig={{
              type: 'text',
              placeholder: 'Username'
            }}
            value={loginForm.username.value}
            invalid={!loginForm.username.isValid}
            shouldValidate
            touched={loginForm.username.touched}
            change={(e) => updateLoginForm(e.target.value, 'username')}
            id='username-input'
            label='Username'
            labelHidden
            inputStyle='main'
          />

          <Input
            elementType={'input'}
            elementConfig={{
              type: 'password',
              placeholder: 'Password'
            }}
            value={loginForm.password.value}
            invalid={!loginForm.password.value}
            shouldValidate
            touched={loginForm.password.touched}
            change={(e) => updateLoginForm(e.target.value, 'password')}
            id='password-input'
            label='Password'
            labelHidden
            inputStyle='main'
          />

          {/* <div className={classes.forgot}>
            <span>forgot password</span>
          </div> */}
        </div>

        <div className={classes['button-box']}>
          {isLoading ? <div className={classes['loader-box']}>
            <Loader size='small' />
          </div> : <Button type='submit' buttonStyle='main' text='Login' />}
        </div>
      </form>
    </div>
  );
};

export default Login;
